import { p as promiseResolve, b as bootstrapLazy } from './index-9d3bd9bc.js';

/*
 Stencil Client Patch Esm v2.19.2 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["chat-nice-sandbox_2",[[0,"chat-nice-sandbox",{"isLazy":[32],"isMobile":[32],"userName":[32],"activeChannel":[32],"statusMessage":[32]}],[1,"nice-chat",{"token":[1],"isMobile":[4,"is-mobile"],"isLazy":[4,"is-lazy"],"hidePreSurvey":[4,"hide-pre-survey"],"userName":[1,"user-name"],"buttonLabel":[513,"button-label"],"height":[1],"showFirstSentMessage":[4,"show-first-sent-message"],"isSendFirstMessageAutomatically":[4,"is-send-first-message-automatically"],"hasFirstAutomatedMessageContent":[1,"has-first-automated-message-content"],"hydrated":[32],"isWidgetOpen":[32],"isSlotPassed":[32],"widgetObserver":[32]},[[0,"click","handleClick"]]]]]], options);
  });
};

export { defineCustomElements };
